import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map, tap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private router: Router) {}
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(

            tap(
                (event: HttpEvent<any>) => {},
                (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        if (
                            (err.status === 401 || err.status === 403) &&
                            (err.url.indexOf('?forLogin') === undefined ||
                                err.url.indexOf('?forLogin') < 0)
                        ) {
                            let source = window.location.href;
                            let docID = null;
                            if(source && source.indexOf('Document') > 0)
                            {
                                console.log('Got document');
                                docID = source.substring(source.lastIndexOf('/')+1);

                            }
                            console.log('Not logged in',docID);
                            // console.log('Requested URL: ' + window.location.href);
                            // window.location.href = environment.logonURL
                            // console.log('Navigating: Audit Interceptor');
                            this.router.navigate(['/Login'],{queryParams:{sourceDocID:docID}});
                        }
                    }
                }
            )
        );
    }
}
